import { connect } from "react-redux";
import DonutList from "../../../../components/donutList/donutList";
import { actionCreators } from "../redux/sagas/revenueDetails/revenueDetails";
import CONSTANTS from "../constants";

export default connect(
  state => ({
    donutValues: state.revenueDetails.revenuesByType.map(rev => ({
      ...rev,
      value: rev.share * 100,
      type: rev.name,
      dollarValue: rev.revenue,
      url: rev.categoryTotalSalesRawDataLink,
      fontSize: 21,
      hasMinusButton: true,
      id: rev.id,
      customTitleStyle: "title-height-60",
      currencySymbol: state.revenueDetails.allRevenues.currencySymbol,
      toolTip: "Percentage change from previous month",
      centerToolTip: "Percentage of Month to Date Revenue"
    })),
    groupValues: state.revenueDetails.revenuesTypes.map(({ title, id }) => ({
      label: title,
      value: id
    })),
    title: "Select Categories",
    module: ".react-section-wrapper.revenueDetailsWidget",
    selectHeight: 350,
    modalHeight: 450,
    modalWidth: 300,
    modalTop: 220,
    maxDonuts: CONSTANTS.MAX_DONUTS,
    maxChecked: state.revenueDetails.revenueTypesCheckedMax
  }),
  {
    onMinusButtonClick: actionCreators.removeRevenueCategory,
    itemWasChecked: items => {
      var keys = Object.keys(items);
      var filtered = keys.filter(function(key) {
        return items[key];
      });
      const maxChecked = filtered.length >= CONSTANTS.MAX_DONUTS;
      return actionCreators.setRevenueTypesChecked({ filtered, maxChecked });
    },
    onSubmit: result => {
      const revenueTypeIds = Object.keys(result.checkedGroups);
      const revenueTypeName = result.groupName;
      return actionCreators.addRevenueChart({ revenueTypeIds, revenueTypeName });
    }
  }
)(DonutList);
